import { getScreenIcon } from '@/modules/templates/lib/dynamic-flow/utils';
import { tWithFallback } from '@/i18n/utils/t-with-fallback';
import { useTranslation } from 'react-i18next';
import { ScreenWithFields } from './DynamicFormContext';

const ScreenHeaderWithIcon = ({ currentScreen }: { currentScreen: ScreenWithFields }) => {
  const { t } = useTranslation();

  // Resolve title / description via UILM. The icon is still keyed off the
  // local title — icons are visual, not user-facing copy, so we don't
  // need them to follow locale.
  const localTitle = currentScreen?.title ?? '';
  const localDescription = currentScreen?.description ?? '';
  const title = tWithFallback(
    t,
    (currentScreen as { uilmTitleKey?: string | null })?.uilmTitleKey,
    localTitle
  );
  const description = tWithFallback(
    t,
    (currentScreen as { uilmDescriptionKey?: string | null })?.uilmDescriptionKey,
    localDescription
  );

  return (
    <>
      <div className="mb-4 space-y-3 py-2 border-b  border-secondary-100">
        <div className="px-4">
          <div className="flex items-center gap-2">
            {localTitle &&
              (() => {
                const IconComponent = getScreenIcon(localTitle);
                return (
                  <div className="w-10 h-10 sm:w-14 sm:h-14 bg-[hsl(var(--brand-primary))/0.1] rounded-2xl flex items-center justify-center text-brand-primary">
                    <IconComponent className="w-5 h-5 sm:w-6 sm:h-6" />
                  </div>
                );
              })()}
            <h2 className="text-lg md:text-2xl  font-semibold text-primary-light font-nunito">
              {title}
            </h2>
          </div>
          {description && <p className="text-secondary-400 font-nunito mt-2">{description}</p>}
        </div>
      </div>
    </>
  );
};

export default ScreenHeaderWithIcon;
